import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Message } from 'src/app/core/class/message';
import { CustomerService } from 'src/app/core/services/customer.service';
import { CommonService } from 'src/app/core/services/common.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { RefuseSuccessComponent } from '../refuse-success/refuse-success.component';
import { ErrorCode } from 'src/app/core/constants/error-code';

@Component({
  selector: 'app-refuse-identify',
  templateUrl: './refuse-identify.component.html',
  styleUrls: ['./refuse-identify.component.scss']
})
export class RefuseIdentifyComponent implements OnInit {

  customerDTO: any
  isSubmitDeclince: boolean = false
  reasonString: string = ''
  formChangesSubscription: Subscription;
  @ViewChild('f', { static: false }) ngForm: NgForm;
  public isFormChanging: boolean;
  private success: boolean;
  hashLink: string = null;
  isNotAttestedUser: boolean = false;

  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private message: Message,
    private toastr: ToastrService,
    private route: Router,
    private customerService: CustomerService,
    public dialogRef: MatDialogRef<RefuseIdentifyComponent>,
    public notificationService: NotificationService,
    public commonService: CommonService,
  ) {
    // this.document = data; // Kiểm tra loại tài khoản KCT
    this.isNotAttestedUser = this.commonService.checkEnterpriseAnonymusType()

  }

  ngOnInit() {
    this.notificationService.subscribeErrorService();
    this.customerDTO = this.data.customerDTO;
    this.hashLink = this.data.hashLink;

  }

  ngAfterViewInit() {
    this.formChangesSubscription = this.ngForm.form.valueChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });

    // Focus on textarea reason after load
    // There's a problem if not setTimeout it will focus on 'reason' then lost focus right after
    setTimeout(_ => document.getElementById('reason').focus(), 500);
  }

  cancel() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: 'messages.confirm_change_data'
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }

  declineInitialSignDocument() {
    // Nếu đã bấm lưu thì retrn, nếu không thì đi tiếp
    if (this.isSubmitDeclince) return
    // Flag để check xem đã bấm lưu chưa
    this.isSubmitDeclince = true;
    const body = {
      hashKey: this.data.hashKey,
      tenantId: this.data.tenantId,
      reason: this.reasonString,
      customerDTO: this.customerDTO
    }
    this.customerService.rejectIndetify(body).subscribe(rs => {
      console.log('rs declineInitialSignDocument',rs)
      if (rs && rs.success) {
        const dialogRef = this.dialog.open(RefuseSuccessComponent, {
          width: '40%',
          data: {
            enterpriseName: this.customerDTO.enterpriseName
          }
        });
        dialogRef.afterClosed().subscribe(rs => {
          this.dialog.closeAll()
          if (this.hashLink) {
            this.route.navigate([`sign-anonymous/${this.data.hashKey}/${this.data.tenantId}/${this.hashLink}`]);
          } else {
            this.route.navigate([`sign-anonymous/${this.data.hashKey}/${this.data.tenantId}`]);
          }
        })
      } else if (rs && !rs.success) {
        this.toastr.error(rs.message)
        if (rs.code === ErrorCode.Identify) {
          this.dialog.closeAll()
          window.scrollTo(0, 0)
          if (this.hashLink) {
            this.route.navigate([`sign-anonymous/${this.data.hashKey}/${this.data.tenantId}/${this.hashLink}/detail`]);
          } else {
            this.route.navigate([`sign-anonymous/${this.data.hashKey}/${this.data.tenantId}/detail`]);
          }
        }
      }
      setTimeout(() => {
        // Bỏ flag
        this.isSubmitDeclince = false;
      }, 1000);
    })
  }
}
